import { render, staticRenderFns } from "./CustomerUnpaidBills.vue?vue&type=template&id=88616e2a&scoped=true&"
import script from "./CustomerUnpaidBills.vue?vue&type=script&lang=ts&"
export * from "./CustomerUnpaidBills.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88616e2a",
  null
  
)

export default component.exports